import { Error } from './Error';

export class ValidationResult {
	public constructor(
		public readonly groupId: string | null,
		public readonly referenceSettingsIsMissing: boolean,
		public readonly productErrors: Error[],
		public readonly countryErrors: Error[]
	) {}
}
